/**
 * Lazyload content images
 */
export async function initLazyLoad(selector = 'img.js-lazy', elementsSelector = '.js-lazy') {
    const {default: LazyLoad} = await import('vanilla-lazyload');
    const lazyImages = document.querySelectorAll(selector);
    return new LazyLoad({elements_selector: elementsSelector, class_loading: 'lazy-loading', use_native: true}, lazyImages);
}